import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const AchIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Ach",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.934 10.3.65 21.7h2.377l.815-2.264h4.87l.813 2.264h2.394L7.621 10.3zm-.391 7.182 1.743-4.87 1.742 4.87zM17.604 10.137q-1.694 0-3.053.757a5.54 5.54 0 0 0-2.133 2.093q-.774 1.336-.773 3.013c0 1.677.256 2.123.773 3.012a5.5 5.5 0 0 0 2.133 2.093q1.36.758 3.053.758.815 0 1.662-.237a4.7 4.7 0 0 0 1.449-.66v-2.312q-.57.506-1.392.807a4.7 4.7 0 0 1-1.637.301q-1.058 0-1.905-.473a3.45 3.45 0 0 1-1.336-1.327q-.488-.855-.488-1.962 0-1.108.488-1.963.489-.855 1.336-1.327c.847-.472 1.2-.472 1.905-.472q.863 0 1.653.293c.79.293.985.467 1.376.814v-2.313a4.7 4.7 0 0 0-1.449-.66 6.2 6.2 0 0 0-1.662-.235M29.085 10.3v4.608h-4.56V10.3h-2.263v11.4h2.263v-4.674h4.56V21.7h2.264V10.3z"
    })
  }));
};
AchIcon.displayName = 'AchIcon';